module.exports = __webpack_public_path__ + "static/media/BIOS.e0bcce2d.jpg";